import {
  CommentsResponse,
  EventCreateBody,
  EventItem,
  EventListResponse,
  FileUploadResponse,
  RegistrationsResponse,
  VendorProductListResponse,
} from "utils/api/client/types"

export class Events {
  private client: unknown

  constructor(client: unknown) {
    this.client = client
  }
  create(
    body: EventCreateBody,
    query?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<EventItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events`, {
        method: "POST",
        headers,
        body,
        query,
      })
    })()
  }

  update(id: string, body: EventCreateBody): Promise<EventItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events/${id}`, {
        method: "PUT",
        body,
      })
    })()
  }

  list(
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<EventListResponse> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events`, {
        headers,
        query: queryParams,
      })
    })()
  }

  retrieve(id: string): Promise<EventItem> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events/${id}`)
    })()
  }

  vendorProducts(
    searchKey: string,
    vendorId: string,
    limit = 20,
    offset = 0
  ): Promise<VendorProductListResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/p_products?q=${searchKey}&offset=${offset}&limit=${limit}&vendor_id=${vendorId}`
      )
    })()
  }

  delete(id: string, headers?: Record<string, unknown>): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(`/admin/events/${id}`, {
        method: "DELETE",
        headers,
      })
    })()
  }

  listComment(
    eventId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<CommentsResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/comments`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  deleteComment(eventId: string, commentId: string) {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/comments/${commentId}`,
        {
          method: "DELETE",
        }
      )
    })()
  }

  listRegistration(
    eventId: string,
    queryParams?: Record<string, unknown>,
    headers?: Record<string, unknown>
  ): Promise<RegistrationsResponse> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/registrations`,
        {
          headers,
          query: queryParams,
        }
      )
    })()
  }

  updateRegistrationStatus(
    eventId: string,
    registrationId: string,
    body: { status: string }
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/registrations/${registrationId}/status`,
        {
          method: "PUT",
          body,
        }
      )
    })()
  }

  createImage(payload: { image: File }): Promise<FileUploadResponse> {
    return (async () => {
      const body = new FormData()
      body.append("image", payload.image)
      return await (this.client as any).fetch(`/admin/events/image`, {
        method: "POST",
        headers: {
          "content-type": null,
        },
        body,
      })
    })()
  }

  resendRegistrationEmail(
    eventId: string,
    registrationId: string
  ): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/registrations/${registrationId}/resend-email`,
        {
          method: "POST",
        }
      )
    })()
  }

  resendApprovedEmails(eventId: string): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/registrations/resend-approved-emails`,
        {
          method: "POST",
        }
      )
    })()
  }

  resendReminder(eventId: string, registrationId: string): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/registrations/${registrationId}/resend-reminder`,
        {
          method: "POST",
        }
      )
    })()
  }

  forceResendReminders(eventId: string): Promise<unknown> {
    return (async () => {
      return await (this.client as any).fetch(
        `/admin/events/${eventId}/send-reminders`,
        {
          method: "POST",
          body: { forceResend: true },
        }
      )
    })()
  }

  exportRegistrations(
    eventId: string,
    queryParams?: Record<string, unknown>
  ): Promise<string> {
    return (async () => {
      // Use the client's fetch which handles auth automatically
      // Request CSV format and get raw text response
      const response = await (this.client as any).fetch(
        `/admin/events/${eventId}/registrations/export`,
        {
          method: "POST",
          query: queryParams,
          headers: {
            Accept: "text/csv",
          },
        }
      )

      // The SDK client may return a Response object or parsed data
      // If it's a Response object, call text() to get CSV string
      if (response && typeof response.text === "function") {
        return await response.text()
      }

      // If response is already a string (CSV), return it
      if (typeof response === "string") {
        return response
      }

      // Fallback: convert to string
      return String(response)
    })()
  }
}
